<template>
    <router-link :to="'/group/'+group.id+'/news/init'" class="container">
        <div class="flex-container" :style='getDynamicStyle()'>
          <div>
            {{group.name}}
          </div>
          <!--<ui-icon  class="user-slash" v-if="!group.authorized" backgroundColor="rgba(0,0,0,0)" color="#FFFFFF" icon="eye"></ui-icon>-->

        </div>
       
      </router-link>
</template>

<script>
import { mapState } from 'vuex';
//import UiIcon from '../../components/UiIcon.vue';

// group object:
//{ "id": "37", "name": "Groep 8", "color_code": "ff7f00", "news_id": "23", "cal_id": "20", "pict_id": "598" }
//:style='getDynamicWidth()'

export default {
  name: 'group-button',
  props:{
    group:{},
  },
  computed:{
    ...mapState(['appSettings'])
  },
  methods:{
    getDynamicStyle(){
      var style={}
      style.backgroundColor= this.group.color_code ? "#"+this.group.color_code :"#F46767";
      style.color="#FFFFFF";

      if(!this.group.authorized){
        style.fontStyle="italic";
      }

      return style;
    },
    
  },
  components:{
    //UiIcon
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container{
  padding:2px;
  text-decoration:none;
  display:inline-block;
  flex:1;
}
.flex-container{
  position:relative;
  width:100%;
  height:100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding:20px;
  border-radius:2px;
}
.user-slash{
  position:absolute;
  top:2px;
  left:2px;
  font-size:.5em;
}
</style>
